export default "__VITE_ASSET__Dc0HUMsa__"